import DatabaseSettings from '../../views/pages/DatabaseSettings';
import Excel from '../../views/pages/Excel';
// import Home from '../../views/pages/Home';
import CreateReport from '../../views/pages/CreateReport';
import EditReport from '../../views/pages/EditReport';
import Reports from '../../views/pages/Reports';
import Trend from '../../views/pages/Trend';
import Users from '../../views/pages/Users';
import Development from '../../views/pages/Development';

export default [{
  path: '/',
  name: 'Home Default',
  component: Reports,
  routes: [{
    path: 'home',
    name: 'Home',
  }],
}, {
  path: '/reports',
  name: 'Reports',
  component: Reports,
  routes: [{
    path: '/inbox',
    name: 'Report List',
  }, {
    path: '/create',
    name: 'Create Report',
    handover: 'u3pzcheb2n',
    component: CreateReport,
  }, {
    path: '/edit/:uuid',
    name: 'Report Edit',
    component: EditReport,
  }, {
    path: '/(delete|duplicate|permissions)',
    name: 'Report Operation',
  }],
}, {
  path: '/trend',
  name: 'Trend',
  component: Trend,
}, {
  path: '/excel',
  name: 'Excel',
  component: Excel,
}, {
  path: '/users',
  name: 'Users',
  component: Users,
  routes: [{
    path: '/inbox',
    name: 'User List',
  }, {
    path: '/(create|edit|delete)',
    name: 'User Operation',
  }],
}, {
  path: '/settings',
  name: 'Database Settings',
  component: DatabaseSettings,
}, {
  path: '/dev/:plugin',
  name: 'Development',
  component: Development,
}];
